import { NgModule } from '@angular/core';

import { DynamicModalComponent } from './modals/dynamic-modal.component';

import { FilterByFieldsPipe } from './pipes/filter-by-fields.pipe';
import { MultiImagePipe } from './pipes/multi-image.pipe';
import { TrimTextPipe } from './pipes/trim-text.pipe';
import { StringifyMinutesPipe } from './pipes/stringify-minutes.pipe';
import { CurrencyFormatPipe } from './pipes/currency-format.pipe';
import { TryToDiscountPricePipe } from './pipes/try-to-discount-price.pipe';
import { I18nDatePipe } from './pipes/i18n-date.pipe';
import { SafePipe } from './pipes/safe.pipe';
import { MultiUrlImagePipe } from './pipes/multi-url-image.pipe';
import { DayNameByTypePipe } from './pipes/day-name-by-type.pipe';

import { MixpanelScriptDirective } from './directives/analytics/mixpanel-script.directive';
import { AdtractionScriptDirective } from './directives/analytics/adtraction-script.directive';
import { WidgetSnippetDirective } from './directives/widget-snippet.directive';
import { LibPhoneNumberDirective } from './directives/lib-phone-number.directive';
import { StickDirective } from './directives/stick.directive';

import { NgbDatepickerI18nService } from './services/ngb-datepicker-i18n.service';
import { UiContextService } from './services/ui-context.service';
import { WebStorageService } from './services/web-storage/web-storage.service';
import { ApiService } from './services/api.service';
import { CacheService } from './services/cache.service';
import { GeoLocationService } from './services/geo-location.service';

import { OutletOrderTimingManager } from './services/outlet-order-timing.manager';
import { AddressLocationManager } from './services/address-location.manager';
import { GoogleTagManagerDirective } from './directives/analytics/google-tag-manager.directive';

const DIRECTIVES = [
  GoogleTagManagerDirective,
  MixpanelScriptDirective,
  WidgetSnippetDirective,
  LibPhoneNumberDirective,
  AdtractionScriptDirective,
  StickDirective,
];
const PIPES = [
  FilterByFieldsPipe,
  TrimTextPipe,
  MultiImagePipe,
  MultiUrlImagePipe,
  StringifyMinutesPipe,
  CurrencyFormatPipe,
  TryToDiscountPricePipe,
  I18nDatePipe,
  SafePipe,
  DayNameByTypePipe,
];
const COMPONENTS = [
  DynamicModalComponent,
];

@NgModule({
  exports: [
    ...DIRECTIVES,
    ...PIPES,
    ...COMPONENTS,

  ],
  declarations: [
    ...DIRECTIVES,
    ...PIPES,
    ...COMPONENTS,
  ],
  providers: [
    ApiService,

    FilterByFieldsPipe,
    TrimTextPipe,
    MultiImagePipe,
    MultiUrlImagePipe,
    StringifyMinutesPipe,
    CurrencyFormatPipe,
    TryToDiscountPricePipe,
    I18nDatePipe,
    SafePipe,
    NgbDatepickerI18nService,
    UiContextService,
    WebStorageService,
    CacheService,
    OutletOrderTimingManager,
    GeoLocationService,
    AddressLocationManager,
  ]
})
export class NgCakeItEasyUtilsModule {
}
